import { ref, computed } from "vue";
import * as Sentry from "@sentry/vue";
import tagsService from "@/services/tags";

const tagList = ref([]);

export function useTags() {
  if (tagList.value.length === 0) {
    tagsService
      .getTagsOrderByCategory()
      .then((response) => (tagList.value = response.data.data.items))
      .catch((error) => {
        Sentry.captureException(error, {
          tags: {
            troubleshooting_note: "Failed to load tags from tags service",
          },
        });
      });
  }

  const getFlatCategoryTags = computed(() => {
    const newTags = [];
    for (const category of tagList.value) {
      if (category?.tags) {
        newTags.push({ id: undefined, name: category.name, category: true });
        for (const tag of category.tags) {
          newTags.push({ id: tag.id, name: tag.name, category: false });
        }
      }
    }
    return newTags;
  });

  const getSpecificCategoryTags = () => {
    return (payload) => {
      const newTags = [];
      const tagCat = tagList.value?.find((val) => val?.name === payload);
      if (tagCat?.tags) {
        newTags.push({ id: undefined, name: tagCat.name, category: true });
        for (const tag of tagCat.tags) {
          newTags.push({ id: tag.id, name: tag.name, category: false });
        }
      }
      return newTags;
    };
  };

  const filterCategoryTagsBySpecificCategories = () => {
    return (payload) => {
      const categories =
        tagList.value?.filter((val) => payload.includes(val?.name)) || [];
      const newTags = [];
      for (const category of categories) {
        if (category?.tags) {
          newTags.push({ id: undefined, name: category.name, category: true });
          for (const tag of category.tags) {
            newTags.push({ id: tag.id, name: tag.name, category: false });
          }
        }
      }
      return newTags;
    };
  };
  return {
    getFlatCategoryTags,
    getSpecificCategoryTags,
    filterCategoryTagsBySpecificCategories,
  };
}
